export default "__VITE_ASSET__BHnebB4K__"